import { List } from "antd"
import { IProject } from "../types/project.type"
import ProjectList from "./ProjectListItem"

const ProjectsList: React.FC<{ projects: IProject[] }> = ({ projects }) => {
  return (
    <List
      itemLayout="vertical"
      dataSource={projects}
      renderItem={(item: IProject) => <ProjectList project={item} />}
    />
  )
}

export default ProjectsList
